var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVkHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41.764mm",
    height: "87.56mm",
    viewBox: "0 0 41.764 87.56",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#002938;}.c{fill:#28a8e0;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.42,
    y: -10.503,
    width: 171.79,
    height: 347.24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48.916 -89.248)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 34.262 94.653)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-89.036 -20.426)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m169.37 235.51c-1.59 0.92-4.65 2.98-6.35 3.67-7.94 3.2-18.63 5.52-26.49 0l-94.62-56.15c-2.12-1.26-4.82 0.22-4.9 2.68l-0.76 22.19c-0.04 1.18 0.57 2.29 1.58 2.9l102.03 60.89c6.15 3.55 13.72 3.55 19.87 0l104.17-60.86c1-0.59 1.61-1.67 1.59-2.84l-0.41-22c-0.05-2.48-2.74-4-4.89-2.77l-90.8 52.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m9.37 98.21 130.75 82.79c6.15 3.55 13.72 3.55 19.87 0l134.52-77.67-145.15 52.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m170.48 175.03 125.35-72.38c3.99-2.3 6.44-6.56 6.44-11.15s-2.45-8.86-6.44-11.17l-134.52-77.67c-6.15-3.55-13.72-3.55-19.87 0l-134.52 77.67c-3.99 2.3-6.44 6.56-6.44 11.17 0 2.3 1.39 8.7 6.44 11.15 0 0 92.84 53.86 125.19 72.54m170.15-53.32-221.54-7.19c-17.85-10.3-17.85-36.06 0-46.37l51.97-30c11.56-6.67 25.81-6.67 37.37 0l51.96 30c17.85 10.3 17.84 36.06 0 46.37l-51.96 30c-11.56 6.67-25.8 6.67-37.36 0l-51.97-30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m182.35 95.63-28.14 16.24c-2.87 1.66-6.4 1.66-9.27 0l-28.14-16.24c-6.18-3.57-6.18-12.49 0-16.06l28.14-16.25c2.87-1.66 6.4-1.66 9.27 0l28.14 16.25c6.18 3.57 6.18 12.49 0 16.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m136.98 171.52v86.42c0 0.7 0.78 1.27 1.74 1.27h23.01c0.96 0 1.74-0.56 1.74-1.26v-86.42c0-0.7-0.78-1.27-1.74-1.27h-23.01c-0.96 0-1.74 0.56-1.74 1.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m275.29 183.07v39.71c0 5.68-3.03 10.93-7.95 13.77 0 0-83.13 48-102.21 59.01-0.67 0.39-1.36 0.72-2.08 1-7.81 2.97-17.91 4.86-25.42-0.43l-101.97-58.87c-5.68-3.28-9.18-9.34-9.18-15.9v-38.29c0.29-16.12 0.18-20.67 0-30.58v-24.94c0-0.88-0.47-1.69-1.23-2.13l-21.56-12.45c-1.64-0.95-3.69 0.23-3.69 2.13v119.26c0 7.98 4.26 15.35 11.16 19.34l128.56 74.24c6.91 3.99 15.42 3.99 22.33 0l128.56-74.24c6.91-3.99 11.16-11.36 11.16-19.34v-119.26c0-1.89-2.05-3.08-3.69-2.13l-21.57 12.46c-0.76 0.44-1.23 1.25-1.23 2.13v24.94"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkHalf);
export default __webpack_public_path__ + "static/media/vk_half.286bd45ea832f7bc6e1460dcf868b9ac.svg";
export { ForwardRef as ReactComponent };